export class Category {

  name: string;
  short: string = '';
  ageFrom: number;
  ageTo: number;
  available: boolean = false;

}
